"use client";

import { PostHogIdentify } from "@nyntax/analytics/posthog-identify";
import { useEffect, useState } from "react";

import { fetchSessionUserId } from "@/lib/session-user";

/**
 * Tells PostHog who the signed-in Learner is, so the funnel joins their visits
 * before and after sign-in. Only the account id is sent, with no properties
 * (the dashboard also sends email and name; the Academy does not need them).
 * A signed-out visitor stays on PostHog's anonymous id.
 *
 * @returns The `PostHogIdentify` element, given the signed-in account id or null.
 */
export const AnalyticsIdentity = () => {
  const [userId, setUserId] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const id = await fetchSessionUserId();

      if (!cancelled) {
        setUserId(id);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, []);

  return <PostHogIdentify userId={userId} />;
};
